import React from 'react';
import { ProgressBar } from 'react-toolbox/lib/progress_bar';
import styles from './LoadingPanel.css';

const LoadingPanel = props =>
  <div className={styles.container}>
    <ProgressBar type="circular" mode="indeterminate" />
    {props.message &&
      <h1 className={styles.message}>
        {props.message}
      </h1>}
  </div>;

export default LoadingPanel;



// WEBPACK FOOTER //
// ./src/general-components/LoadingPanel.js